import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { NotFoundErrorType } from '@src/app/features/resource-not-found-page/enums/not-found-error.type';
import { GenericPageComponent } from '@shared/modules/general-commons/components/generic-page/generic-page.component';

@Component({
  templateUrl: './resource-not-found-page.component.html',
  imports: [GenericPageComponent, TranslateModule]
})
export class ResourceNotFoundPageComponent extends BaseComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  public readonly errorTypeEnum = NotFoundErrorType;
  errType: NotFoundErrorType;

  ngOnInit() {
    this.connectRouteData();
  }

  private connectRouteData(): void {
    this.subSink.sink = this.route.data.subscribe(data => {
      this.errType = data.errorType;
    });
  }
}

@NgModule({
  imports: [CommonModule, TranslateModule, GeneralCommonsModule, ResourceNotFoundPageComponent]
})
export class NotFoundPageModule {}
